"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const react_1 = __importDefault(require("react"));
const Text_styles_1 = require("./Text.styles");
/**
 * @deprecated please use <Ds.Text> instead
 */
const Text = ({ as = "p", variant = "body", colour = null, skinny = false, className, children, props, }) => {
    return (react_1.default.createElement(Text_styles_1.StyledText, Object.assign({ as: as, variant: variant, colour: colour, skinny: skinny, className: className }, props), children));
};
exports.Text = Text;
//# sourceMappingURL=Text.js.map